import React,{ Component } from 'react';


import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'

import PieChart from 'recharts/es6/chart/PieChart'
import Pie from 'recharts/es6/polar/Pie'
import Sector from 'recharts/es6/shape/Sector'
import ResponsiveContainer from 'recharts/es6/component/ResponsiveContainer'



const renderActiveShape = (props, centerText, title, dataType, yDataType, valuePrefix, theme, fontSize) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
    fill, payload, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';
  fontSize = fontSize ? fontSize : 1
  return (
    <g>

      <text x={cx} y={cy} dy={-20} textAnchor="middle" fill={theme.palette.primary.dark} style={{fontFamily: 'Kanit', fontWeight:"bold",fontSize: 35*fontSize}}>{title}</text>
      <text x={cx} y={cy} dy={title ? 40*fontSize:20} textAnchor="middle" fill={theme.palette.primary.dark} style={{fontFamily: 'Kanit', fontSize: title ? 50*fontSize : 70*fontSize}}>{centerText}</text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={theme.palette.primary.gold}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={theme.palette.primary.gold}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
      <circle cx={ex} cy={ey} r={2} fill={theme.palette.primary.gold} stroke="none"/>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} style={{fontFamily: 'Kanit'}} fill={theme.palette.primary.dark}>
        {
          yDataType === "date" ? moment.months(Math.floor(payload.name)) : payload.name
        }

      </text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} style={{fontFamily: 'Kanit'}} fill="#B38728">
          {
            dataType === "procentage" && `${(value).toFixed(2)}%`
          }
          {
            dataType === "number" && value+" "+(valuePrefix ? valuePrefix : "")
          }
      </text>
    </g>
  )
}


const styles = theme => ({

});



class PieGraph extends Component{

  state = {
    activeIndex: 0,
  }


  onPieEnter = (data, index)=> {
    this.setState({
      activeIndex: index,
    });
  }

	render () {

  	return (
      <ResponsiveContainer width="100%" height="100%">
        <PieChart >
          <Pie
          	activeIndex={this.state.activeIndex}
            activeShape={(e)=>renderActiveShape(e, this.props.centerText, this.props.title, this.props.dataType, this.props.yDataType, this.props.valuePrefix, this.props.theme, this.props.fontSize )}
            dataKey="value"
            data={this.props.data}

            innerRadius={"45%"}
            outerRadius={"70%"}
            fill={this.props.theme.palette.primary.lightdark}
            onMouseEnter={this.onPieEnter}
          />
         </PieChart>
      </ResponsiveContainer>

    );
  }
}


PieGraph.propTypes = {


};

export default withStyles(styles)(PieGraph);



// WEBPACK FOOTER //
// ./src/components/reusableComponents/PieGraph.js